import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
    View,
    Text,
    TextInput,
    StyleSheet
} from 'react-native'


export default class PinInput extends Component {
    static propTypes = {
        pinSubmit: PropTypes.func.isRequired,
        pinOutput: PropTypes.func,
        pinCount: PropTypes.number,
        pinStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
        editable: PropTypes.bool
    };

    static defaultProps = {
        pinCount: 4,
        pinStyle: {},
        editable: true
    };

    constructor(props) {
        super(props);

        this.pinCount = props.pinCount;
        this.inputRefs = [];

        this.state = { pin: new Array(this.pinCount).fill('') };
    }

    clean = () => {
        this.setState({ pin: new Array(this.pinCount).fill('') });
        this.focus(0);
    }

    focus = (idx) => {
        this.inputRefs[idx].focus();
    }

    isFocus = (idx) => {
        let newPin = this.state.pin;

        for (let i = 0; i < newPin.length ; i++){
            if (i >= idx) newPin[i] = '';
        }

        this.setState({ pin: newPin });
    }

    handleEdit = (pin, idx) => {
        if (/[^\d]/g.test(pin)) return;

        let newPin = this.state.pin;
        newPin[idx] = pin;

        this.props.pinOutput(newPin.join(''));

        // User filling the last pin ?
        if (idx === this.pinCount - 1) {
            this.props.pinSubmit(newPin.join(''));
            this.clean();

            return;
        }

        this.focus(idx + 1);
        this.setState({ pin: newPin });
    }

    componentDidMount() {
        this.focus(0);
    }

    render() {
        const { error, editable, pinStyle } = this.props

        return (
            <View>
                <View style={styles.container}>
                    {this.state.pin.map((v, idx) => {
                        return (
                            <TextInput key={ idx }
                                ref={(ref) => this.inputRefs[idx] = ref}
                                onChangeText={(pin) => this.handleEdit(pin, idx)}
                                onFocus={() => this.isFocus(idx)}
                                editable={editable}
                                value={ this.state.pin[idx] }
                                style={[{ textAlign: 'center' }, pinStyle]}
                                underlineColorAndroid={ 'transparent' }
                                keyboardType={ 'numeric' }
                                returnKeyType={ 'send' }
                                autoCapitalize={ 'none' }
                                autoCorrect={ false} />
                        );
                    })}
                </View>
                <Text style={styles.erroDescInputCenter}>
                    {error}
                </Text>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    erroDescInputCenter: {
        textAlign: 'center',
        color: '#D75A5A',
    }
});



// WEBPACK FOOTER //
// ./src/components/pinInput/index.js